export default __webpack_public_path__ + "static/media/Logo_Arburg.eae28b82.svg";